import { render, staticRenderFns } from "./ReassignHistories.vue?vue&type=template&id=6b048fd2&scoped=true&"
import script from "./ReassignHistories.vue?vue&type=script&lang=js&"
export * from "./ReassignHistories.vue?vue&type=script&lang=js&"
import style0 from "./ReassignHistories.vue?vue&type=style&index=0&id=6b048fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b048fd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b048fd2')) {
      api.createRecord('6b048fd2', component.options)
    } else {
      api.reload('6b048fd2', component.options)
    }
    module.hot.accept("./ReassignHistories.vue?vue&type=template&id=6b048fd2&scoped=true&", function () {
      api.rerender('6b048fd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/ReassignHistories.vue"
export default component.exports